import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";
import { AuthService } from '../../services/auth.service';
import { UserIdentity } from "../../models/user-identity.model";

import { Claim } from '../../admin/models/claim.model';

@Injectable()
export class SystemPermissionGuardService  {

    constructor(
        public authService: AuthService,
        public router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const unauthorized$ = of(this.router.createUrlTree(['/home/unauthorized', { ref: state.url }], /* Removed unsupported properties by Angular migration: skipLocationChange. */ {}));
        let requiresOneOf: Claim[] = route.data["claims"] as Claim[];
        let obs$: Observable<boolean | UrlTree>;
        obs$ = this.authService.token$.pipe(
            take(1),
            mergeMap((token: string) => {
                let returnObs$: Observable<boolean | UrlTree> = of(false);
                if (token == null || token === "") {
                    returnObs$ = this.authService.setProfile().pipe(
                        mergeMap((identity: UserIdentity) => {
                            return (identity.isLoggedIn)
                                ? this.getPermissionObservable(route, requiresOneOf).pipe(
                                    mergeMap((data: boolean) => {
                                        return (data) ? of(true) : unauthorized$;
                                    }))
                                : unauthorized$;
                        })
                    );
                } else {
                    return of(this.authService.isLoggedIn).pipe(
                        mergeMap((isLoggedIn) => {
                            return (isLoggedIn)
                                ? this.getPermissionObservable(route, requiresOneOf).pipe(
                                    mergeMap((data: boolean) => {
                                        return (data) ? of(true) : unauthorized$;
                                    }))
                                : unauthorized$;
                        })
                    );
                }
                return returnObs$;
            }))
        return obs$;
    }

    getPermissionObservable(route: ActivatedRouteSnapshot, requiredClaims: Claim[]): Observable<boolean> {
        let obs$: Observable<boolean> = (requiredClaims != null)
            ? of(requiredClaims.filter(x => this.authService.User.hasPermission(x.type, x.value)).length > 0)
            : of(this.authService.hasSystemPermission(route.data["permission"]) != null);
        return obs$;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const requiresOneOf: Claim[] = childRoute.data["claims"] as Claim[];
        if (requiresOneOf) {
            const foundClaims = requiresOneOf.filter(x => this.authService.User.hasPermission(x.type, x.value));
            return foundClaims.length !== 0;
        }
        else
            return !!this.authService.hasSystemPermission(childRoute.data["permission"]);
    }

}
